// Centralized API configuration
export const getApiBaseUrl = () => {
  const apiUrl = import.meta.env.VITE_API_URL;
  
  // If no API URL is set, use production as fallback
  if (!apiUrl) {
    return 'https://tag-generator-api.tchallasolutions.com/api';
  }
  
  // Ensure the URL ends with /api
  return apiUrl.endsWith('/api') ? apiUrl : `${apiUrl}/api`;
};

export const getApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${baseUrl}/${cleanEndpoint}`;
};

export const getPublicApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  // Remove /api suffix for public endpoints that need the base domain
  const cleanBaseUrl = baseUrl.replace(/\/api$/, '');
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${cleanBaseUrl}/api/${cleanEndpoint}`;
};

// Debug helper
export const logApiConfig = () => {
  console.log('🔧 API Configuration:', {
    REACT_APP_API_URL: import.meta.env.VITE_API_URL,
    NODE_ENV: import.meta.env.MODE,
    baseUrl: getApiBaseUrl(),
    sampleEndpoint: getApiUrl('events'),
    samplePublicEndpoint: getPublicApiUrl('events/1/registration-config')
  });
};
